import { render, staticRenderFns } from "./StaffCreateForm.vue?vue&type=template&id=4888a82e&scoped=true&"
import script from "./StaffCreateForm.vue?vue&type=script&lang=js&"
export * from "./StaffCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888a82e",
  null
  
)

export default component.exports